import {IsEmail} from 'class-validator';

export default class RecoveryEmailData {
  @IsEmail()
  public email = '';
}
